import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { boolean } from 'yup';


interface IPayorDashSlice {
  showColumnSettings:boolean;
  selection:any
}

const initialState: IPayorDashSlice = {
  showColumnSettings:false,
  selection:{}
};

export const payorDashboardSlice = createSlice({
  name: 'payorDashboardSlice',
  initialState,
  reducers: {
    toggleColumnSettingsPayorDash:(state,action)=>{
        state.showColumnSettings = action.payload
    },
    updateSelectedRow:(state,action)=>{
      state.selection = action.payload
  }
  },
});

export const { toggleColumnSettingsPayorDash,updateSelectedRow} = payorDashboardSlice.actions;

export default payorDashboardSlice.reducer;
